// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".snackbarContent[data-v-8e4fc48a]{min-width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.centered[data-v-8e4fc48a]{text-align:center}.closeButton[data-v-8e4fc48a]{position:absolute;right:8px;top:8px}", ""]);
// Exports
module.exports = exports;
